export function showToast(message, type = "success") {
  window.dispatchEvent(new CustomEvent("tupi:toast", { detail: { message, type } }));
}
